export const CREATE_LEVEL_FORM_NAME = 'createLevel'
export const EDIT_LEVEL_FORM_NAME = 'editLevel'
export const LEVEL_NAME_LENGTH = 20
export const TEAM_FORM_PROTRACK_LEVEL = 'teamFormProtrackLevel'

export const LEVEL_TYPE_MICROACTION = 'microaction';
export const LEVEL_TYPE_LIBRARY = 'library';

export const TypeOfLevel = {
  [LEVEL_TYPE_MICROACTION]: LEVEL_TYPE_MICROACTION,
  [LEVEL_TYPE_LIBRARY]: LEVEL_TYPE_LIBRARY,
}
